import { cn } from '@/lib/utils';
import { navItemStyles } from './styles';
import { Link, LinkProps } from 'react-router-dom';
import { ReactNode } from 'react';

export function NavItemInternalLink({
  className,
  children,
  to,
  ...props
}: LinkProps & {
  children: ReactNode;
}) {
  return (
    <Link
      to={to}
      className={cn(navItemStyles(), 'flex items-center gap-2', className)}
      {...props}>
      {children}
    </Link>
  );
}
